var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"my-4"},[_c('b-col',{staticClass:"footer-col fixed-footer text-right",attrs:{"sm":"12"}},[(_vm.copyOwner.length > 0)?_c('span',{staticClass:"copy-owner"},[_vm._v(_vm._s(_vm.copyOwner + ' Copy'))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }